import React, { useRef, useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCar, faTruck, faTachometerAlt, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ReactEcharts from 'echarts-for-react';
import { NavLink } from 'react-router-dom';

import API_PATH from "../../constants/config.json";
import { setCookie, getPrivileges } from './../../functions/Auth';

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Start Css code ...
const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '98%',
    },
  },
  rootBox: {
    flexGrow: 1,
  },
  paper: {
    width: '100%',
    boxShadow: 'none',
  },
  midMainContainer: {
    background: '#fff',
    borderRadius: '5px',
    padding: '0px',
    borderRadius: '5px',
    '@media only screen and (max-width: 3500px)': {
      width: '500px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '895px',
      maxWidth: '900px',
    },
  },
  midBlock: {
    position: 'fixed',
    background: '#fff',
    left: '-2px',
    zIndex: '33',
    borderRadius: '5px',
    bottom: '5px',
    border: '1px solid #24618E',
    height: '86.8vh', 
    width: '505px',
    '@media only screen and (max-height: 820px)': {
      height: '83vh'
    },
  },
  capitalize: {
        textTransform: 'capitalize'
      },
  formHead: {
    padding: '15px 15px 15px 15px',
    overflow: 'hidden',
    '& h3': {
      color: '#24618E',
      fontSize: '25px',
      marginTop: '0px',
      marginBottom: '-10px',
    },
    '& img': {
      width: '100%',
      height: '2px',
    },
    '& h2': {
      '@media only screen and (min-width: 3501px)': {
        fontSize: '25pt',
      },
    }
  },
  teamsUl: {
    paddingLeft: '5px !important',
    paddingTop: 0,
    margin: 0,
    width: '100%',
    float: 'left',
    '& li': {
      listStyle: 'none',
      float: 'left',
      textAlign: 'center',
      marginLeft: '50px'
    },
  },
  btnIcon: {
    color: '#24618E',
    marginRight: '5px',
  },
  btnIcons: {
    color: '#24618E',
    marginRight: '5px',
    cursor: 'pointer',
  },
  fieldsetname: {
    width: 'auto',
    border: '1px solid rgba(0, 167, 93, 1)',
    margin: '10px',
    padding: '10px',
    borderRadius: '5px',
    '& .MuiPaper-elevation1': {
      boxShadow: 'none',
    }
  },
  simpleBtn: {
    marginTop: '0px',
    border: '1px solid #333',
    color: '#333',
    background: '#fff !important',
    fontSize: '12px',
    width: '110px',
  },
  floatLeftBtn: {
    float: 'left'
  },
  floatRightBtn: {
    float: 'right',
    '@media only screen and (max-width: 3500px)': {
      width: '180px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '275px',
    },
  },
  floatCenterBtn: {
    clear: 'both',
    border: '1px solid #333',
    padding: '5px 25px',
    color: '#333',
    '@media only screen and (min-width: 3501px)': {
      width: '180px',
    },
  },
  tableHead: {
    fontWeight: 'bolder',
    textAlign: 'center',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '18px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '24pt',
      paddingTop: '15px !important',
    },
    padding: 0,
    '& p': {
      margin: '0',
    }
  },
  titleTD: {
    textAlign: 'left',
    padding: 0,
    '@media only screen and (max-width: 3500px)': {
      fontSize: '18px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '24pt',
    },
  },
  dataTD: {
    textAlign: 'center',
    padding: 0,
    '@media only screen and (max-width: 3500px)': {
      fontSize: '18px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '24pt',
    },
  },
  tableMidBlock: {
    '& td': {
      border: '1px solid #D7D7D7',
      padding: '5px'
    },
    '& th': {
      border: '1px solid #D7D7D7',
      padding: '5px',
      '&:first-child': {
        border: 'none',
      }
    }
  },
  topIntPanelBtn: {     
     width: '67%',
     float: 'right',
     marginBottom: '10px',
     '& button': {
       background: '#fff',
       color: '#333',
       border: '1px solid #333',
       '&:hover': {
         boxShadow: '4px 3px 3px 0px #999',
         background: '#fff',
       }
     }
  },
  echartDiv: {
    border: '1px solid #D7D7D7',
    marginTop: '-10px',
  },
  closePara: {
    '& :hover': {
      color: '#CC0000',
      cursor: 'pointer',
    }
  },
  closeIcon: {
    textAlign: 'right',
    margin: '0',
    position: 'absolute',
    top: '10px',
    cursor: 'pointer',
    color: '#24618E',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '20pt',
      right: '10px',
      width: '40px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '30pt',
      right: '15px',
      width: '60px',
    },
    '&:hover': {
      color: '#CC0000',
    }
  },
  tableMidBlock: {
    '& td': {
      border: '1px solid #D7D7D7',
      padding: '5px'
    },
    '& th': {
      border: '1px solid #D7D7D7',
      '@media only screen and (max-width: 3500px)': {
        padding: '5px',
      },
      '@media only screen and (min-width: 3501px)': {
        padding: '15px 5px',
      },
    },
    '& tbody.MuiTableBody-root tr.MuiTableRow-root:nth-child(odd)': {
      backgroundColor: ' #f2f2f2 !important',
    },
  }
}));
//End Css code ...


const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

//Start MidBlock component code ...
const MidBlock = props => {

  let stationData = props.stationData;
  let msWidth = window.innerHeight;

  // This code is use to get window viewport height
  if (window.screen.width >= 100 && window.screen.width <= 1500) {
    msWidth = window.innerWidth;
  }
  else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
    msWidth = window.innerWidth;
  }
  else if (window.screen.width >= 3501) {
    msWidth = window.innerWidth;
  }
  else {
    msWidth = window.innerWidth;
  }
  // This code is use to get window viewport height

  useEffect(() => {
    getStationRecentYear();
    getsummaryData();
    GetADTeChart();
  }, [props.searchPanel]);


  const [spacing, setSpacing] = React.useState(2);
  const classes = useStyles();
  const myRef = useRef(null);
  const axios = require('axios');

  const [volumeCountDate, setVolumeCountDate] = React.useState();
  const [volumeClassCountDate, setVolumeClassCountDate] = React.useState();
  const [traffiSpeedCountDate, setTraffiCountDate] = React.useState();

  const [yearList, setYearList] = React.useState([]);
  const [getADTSummery, setGetADTSummery] = React.useState([]);
  const [getTruckPercent, setGetTruckPercent] = React.useState([]);
  const [getADTGrowthFactor, setGetADTGrowthFactor] = React.useState([]);

  const [eChartYear, setEChartYear] = React.useState([]);
  const [eChartData, setEChartData] = React.useState([]);
  const [eChartTrendLineData, setEChartTrendLineData] = React.useState([]);
  const [eChartGet, seteChartGet] = React.useState(0);
  const [midBlockScreenWidth, setMidBlockScreenWidth] = React.useState(msWidth);

  const [getchart, setchart] = React.useState([]);

  // This code is use to change window viewport height
  window.onresize = function () {
    if (window.screen.width >= 100 && window.screen.width <= 1500) {
      msWidth = window.innerWidth;
      setMidBlockScreenWidth(msWidth);
    }
    else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
      msWidth = window.innerWidth;
      setMidBlockScreenWidth(msWidth);
    }
    else if (window.screen.width >= 3501) {
      msWidth = window.innerWidth;
      setMidBlockScreenWidth(msWidth);
    }
    else {
      msWidth = window.innerWidth;
      setMidBlockScreenWidth(msWidth);
    }
  };
  // This code is use to change window viewport height

  //This function is used for set Chart ... Start
  const myOptions = {
    color: ["#3398DB"],
    title: {
      text: null
    },
    grid: {
      bottom: midBlockScreenWidth >= 1200 && midBlockScreenWidth <= 3500 ? '60px' : midBlockScreenWidth >= 3501 ? '75px' : '50px',
      top: '20px',
      left: midBlockScreenWidth >= 1200 && midBlockScreenWidth <= 3500 ? '60px' : midBlockScreenWidth >= 3501 ? '100px' : '50px',
      right: '15px'
    },
    tooltip: {
      trigger: 'item',

      formatter: (params, index) => {
        let res = '';
        let colorCumulative = ['#696969', '#428adc'];
        var colorSpan = (color) => '<span style="display:inline-block;margin-right:5px;margin-top:5px;border-radius:10px;width:9px;height:9px;float:left;background-color:' + color + '"></span>';
        if ((params.componentType == "series") && (params.componentSubType == 'line')) {
          res += '<span style="float:left">' + parseFloat(params.data[0]) + '</span>' +
            ' <br/>' + colorSpan(colorCumulative[1]) + '<span style="float:left">' + params.data[2] + '</span>';
        }
        return res;
      }

    },
    legend: {
      data: []
    },
    xAxis: [{
      type: "value",
      interval: 1,
      min: (eChartYear.length > 1 ? Math.min(...eChartYear) : (eChartYear[0]) - 1),
      max: (eChartYear.length > 1 ? Math.max(...eChartYear) : (eChartYear[0]) + 1),
      splitLine: {
        show: false
      },
      axisLabel: {
        rotate: 45,
        fontSize: midBlockScreenWidth >= 1200 && midBlockScreenWidth <= 3500 ? 13 : midBlockScreenWidth >= 3501 ? 24 : 12,
        formatter: function (value, index) {
          return parseInt(value.toString().replace(",", ""));
        }
      },

    }],
    yAxis: {
      type: 'value',
      splitLine: {
        show: true
      },
      axisLabel: {
        fontSize: midBlockScreenWidth >= 1200 && midBlockScreenWidth <= 3500 ? 13 : midBlockScreenWidth >= 3501 ? 24 : 12,
      },
      scale: true
    },
    series: [
      {
        name: 'Volume Growth',
        type: 'line',
        symbolSize: 16,
        data: getchart,
        lineStyle: {
          type: 'solid',
          color: "#3b3b3b",
          width: 3
        },
      },
      {
        type: 'line',
        data: eChartTrendLineData,
        symbol: 'none',
        lineStyle: {
          type: 'dashed',
          color: "#7e9ed6",
          width: 3
        },
        label: {
          show: false
        },
      }
    ]
  };
  //This function is used for set Chart ... End

  //This function is used for regression ... Start
  const regression = (x, y, typ) => {
    var type = (typ == null) ? 'linear' : typ;
    var N = x.length;
    var slope;
    var intercept;
    var SX = 0;
    var SY = 0;
    var SXX = 0;
    var SXY = 0;
    var SYY = 0;
    var Y = [];
    var X = [];

    if (type == 'linear') {
      X = x;
      Y = y;
    }
    else if (type == 'exp' || type == 'exponential') {
      for (var i = 0; i < y.length; i++) {
        if (y[i] <= 0) {
          N--;
        }
        else {
          X.push(x[i]);
          Y.push(Math.log(y[i]));
        }
      }
    }

    for (var i = 0; i < N; i++) {
      SX = SX + X[i];
      SY = SY + Y[i];
      SXY = SXY + X[i] * Y[i];
      SXX = SXX + X[i] * X[i];
      SYY = SYY + Y[i] * Y[i];
    }

    slope = (N * SXY - SX * SY) / (N * SXX - SX * SX);
    intercept = (SY - slope * SX) / N;

    return [slope, intercept];
  }
  //This function is used for regression ... End

  //This function is used for linear expression ... Start
  const linearRegression = (X, Y) => {
    var ret;
    ret = regression(X, Y, 'linear');
    return [ret[0], ret[1]];
  }
  //This function is used for linear expression ... End


  //This function is used for regular expression ... Start
  const expRegression = (X, Y) => {
    var ret;
    var x = X;
    var y = Y;
    ret = regression(x, y, 'exp');
    var base = Math.exp(ret[0]);
    var coeff = Math.exp(ret[1]);
    return [base, coeff];
  }
  //This function is used for regular expression ... End


  //This function is used for fit Data ... Start
  const fitData = (data, typ) => {
    var type = 'linear';
    var ret;
    var res;
    var x = [];
    var y = [];
    var ypred = [];

    for (i = 0; i < data.length; i++) {
      if (data[i] != null && Object.prototype.toString.call(data[i]) === '[object Array]') {
        if (data[i] != null && data[i][0] != null && data[i][1] != null) {
          x.push(data[i][0]);
          y.push(data[i][1]);
        }
      }
      else if (data[i] != null && typeof data[i] === 'number') {//If type of X axis is category
        x.push(i);
        y.push(data[i]);
      }
      else if (data[i] != null && Object.prototype.toString.call(data[i]) === '[object Object]') {
        if (data[i] != null && data[i].x != null && data[i].y != null) {
          x.push(data[i].x);
          y.push(data[i].y);
        }
      }
    }

    if (type == 'linear') {

      ret = linearRegression(x, y);
      for (var i = 0; i < x.length; i++) {
        res = ret[0] * x[i] + ret[1];
        ypred.push([x[i], res]);
      }

      return {
        data: ypred,
        slope: ret[0],
        intercept: ret[1],
        y: function (x) {
          return (this.slope * x) + this.intercept;
        },
        x: function (y) {
          return (y - this.intercept) / this.slope;
        }
      };
    }
    else if (type == 'exp' || type == 'exponential') {

      ret = expRegression(x, y);
      for (var i = 0; i < x.length; i++) {
        res = ret[1] * Math.pow(ret[0], x[i]);
        ypred.push([x[i], res]);
      }
      ypred.sort();

      return {
        data: ypred,
        base: ret[0],
        coeff: ret[1]
      };
    }
  }
  //This function is used for fit Data ... End


  //This function is used for go to midblock details page ... Start
  const goToMidblockDetails = () => {
    setCookie("latitude", stationData.latitude);
    setCookie("longitude", stationData.longitude);
    window.open('/midblock_details?station=' + stationData.client_station_id, '_blank');
  }
  //This function is used for go to midblock details page ... End

  //This function is used for export data
  const setExportData = () => {
    props.groupStations(stationData.station_id, stationData.station_type, stationData.client_station_id, stationData.station_location);
    props.checkExportValue();
  }
  //This function is used for export data

  //This method is use for API call to get recent year station Data .... Start
  const getStationRecentYear = () => {
    try {
      axios({
        method: 'post',
        url: API_URL + API_PATH.getStationRecentYear,
        data: {
          stationId: stationData.station_id
        }
      }).then(function (response) {
        if (response && response.data.data) {
          setVolumeCountDate(response.data.data.volumeyear);
          setVolumeClassCountDate(response.data.data.classyear);
          setTraffiCountDate(response.data.data.speedyear);
        } else {
        }
      })
    }
    catch (error) {
    }
  }
  //This method is use for API call to get recent year station Data .... End


  //This method is use for API call to get ADT chart Data .... Start
  const GetADTeChart = () => {
    try {
      axios({
        method: 'post',
        url: API_URL + API_PATH.getADT,
        data: {
          stationId: stationData.station_id,
        }
      }).then(function (response) {
        if (response && response.data.data) {
          let ADTData = [];
          let ADTYear = [];

          let datas = [];

          seteChartGet(response.data.data.length);
          for (let i = 0; i < response.data.data.length; i++) {

            let adt = parseInt(response.data.data[i].adt.replace(/,/g, ''));
            let adtHover = response.data.data[i].adt;
            let year = parseInt(response.data.data[i].cnt_year);

            datas.push([year, adt, adtHover]);

            ADTData.push(adt);
            ADTYear.push(year);

          }
          let trend_source_data = [];

          for (let i = ADTData.length; i-- > 0;) {
            trend_source_data[i] = [i, ADTData[i]]
          }
          let regression_data = fitData(trend_source_data).data
          let trend_line_data = [];
          for (let i = regression_data.length; i-- > 0;) {
            trend_line_data[i] = regression_data[i][1];
          }

          let trendArray = [];

          trend_line_data.map((trendValue, index) => {

            trendArray.push([datas[index][0], trendValue])
          })


          let tempData = findLineByLeastSquares(ADTYear, ADTData).reverse();
          setEChartTrendLineData(tempData);

          let yearADT = ADTYear.map((i) => parseInt(i));

          setEChartData(ADTData.reverse());

          setEChartYear(yearADT.reverse());

          setchart(datas);

        }
        else {
        }

      })
    }
    catch (error) {
    }
  }
  //This method is use for API call to get ADT chart Data .... End


  //This method is use for API call to get summary Data .... Start
  const getsummaryData = () => {
    try {
      axios({
        method: 'post',
        url: API_URL + API_PATH.getMidblockSummary,
        data: {
          stationId: stationData.station_id
        }
      }).then(function (response) {
        if (response && response.data.data) {
          setGetADTSummery(response.data.data[0].adt);
          setGetTruckPercent(response.data.data[1].truckpercent);
          setGetADTGrowthFactor(response.data.data[2].growthrate);
          setYearList(response.data.data[0].adt);
        } else {
        }
      })
    }
    catch (error) {
    }
  }
  //This method is use for API call to get summary Data .... End

  //This method is use for find line square .... Start
  function findLineByLeastSquares(values_x, values_y) {
    var x_sum = 0;
    var y_sum = 0;
    var xy_sum = 0;
    var xx_sum = 0;
    var count = 0;

    /*
     * The above is just for quick access, makes the program faster
     */
    var x = 0;
    var y = 0;
    var values_length = values_x.length;

    if (values_length != values_y.length) {
      throw new Error('The parameters values_x and values_y need to have same size!');
    }

    /*
     * Above and below cover edge cases
     */
    if (values_length === 0) {
      return [[], []];
    }

    /*
     * Calculate the sum for each of the parts necessary.
     */
    for (let i = 0; i < values_length; i++) {
      x = values_x[i];
      y = values_y[i];
      x_sum += x;
      y_sum += y;
      xx_sum += x * x;
      xy_sum += x * y;
      count++;
    }

    /*
     * Calculate m and b for the line equation:
     * y = x * m + b
     */
    var m = (count * xy_sum - x_sum * y_sum) / (count * xx_sum - x_sum * x_sum);
    var b = (y_sum / count) - (m * x_sum) / count;

    /*
     * We then return the x and y data points according to our fit
     */
    var result_values_x = [];
    var result_values_y = [];

    var totalRsult = [];

    for (let i = 0; i < values_length; i++) {
      x = values_x[i];
      y = x * m + b;
      result_values_x.push(x);
      result_values_y.push(y);

      totalRsult.push([x, y]);
    }

    return totalRsult;

  }
  //This method is use for find line square .... End


  return (
    <React.Fragment>
      <CssBaseline />
      <div className={classes.midBlock} ref={myRef} style={props.showExternalLayers ? {left: props.sidebarWidth} : {left: '-2px'}}>
        <Container maxWidth="sm" className={['midBlockContainer',classes.container, classes.midMainContainer]}>
          <div className={classes.formHead}>
            {
              props.searchChecked ?
                <p style={{ marginBottom: '10px', marginTop: '0' }}>
                  <NavLink to="#" style={{ color: '#24618E' }} onClick={() => props.passMidValue()}>
                    <FontAwesomeIcon icon={faAngleLeft} />&nbsp;Back to Search Results
                </NavLink>
                </p> :
                null
            }
            <span > Midblock Station ID: {stationData && stationData.client_station_id ? stationData.client_station_id : <span> N/A </span>} </span>
            <h2 style={{ margin: 0, marginBottom: '-12px', padding: 0 }}> {stationData && stationData.station_location ? stationData.station_location : <span> N/A </span>} </h2>
            <p className={classes.closeIcon} onClick={props.passMidValue}>
              <FontAwesomeIcon icon={faTimes} className={classes.btnIcons} title='Close' />
            </p>
            <img src={require('../../assets/images/hrimg.svg')} />
            <Grid xs={12} item style={{ marginTop: "10px" }}>
              <Paper className={classes.paper} style={{ textAlign: 'center' }} >
                <div className={classes.topIntPanelBtn}>
                  {
                    getPrivileges().length !== 0 ?
                      <> <Button variant="outlined" id="export_btn" onClick={() => setExportData()} data-testid="export_btn" className={classes.simpleBtn, classes.floatCenterBtn} disabled={volumeCountDate || volumeClassCountDate || traffiSpeedCountDate ? false : true}>
                        Export
                  </Button>
                        <Button variant="outlined" id="view_all_details_btn" data-testid="view_all_details_btn"
                          className={classes.simpleBtn, classes.floatRightBtn}
                          onClick={goToMidblockDetails}>
                          View All Details
                 </Button>
                      </>
                      :
                      null
                  }
                </div>
              </Paper>
            </Grid>
          </div>
          <div className={props.searchChecked ? 'withSearch' : 'withoutSearch'}>
            <Typography component="div" className={getPrivileges().length === 0 ? 'stationBlocktypoBlank' : 'stationBlocktypo'}>
              <fieldset className={classes.fieldsetname} style={{ paddingTop: 0, marginTop: 0 }}>
                <legend>Most Recent Data Types</legend>
                <Grid container className={classes.rootBox} spacing={spacing}>
                  <Grid item xs={12}>
                    <Grid container justify="center" spacing={spacing}>
                      <Grid xs={12} item>
                        <Paper className={classes.paper}>
                          {
                            (volumeCountDate || volumeClassCountDate || traffiSpeedCountDate) ?
                              <ul className={classes.teamsUl}>
                                {
                                  volumeCountDate ?
                                    <li style={{ marginLeft: '0px', marginRight: '50px' }} title='Volume'>
                                      <FontAwesomeIcon icon={faCar} className={classes.btnIcon} /> <br />
                                      {volumeCountDate}
                                    </li> : null
                                }
                                {
                                  volumeClassCountDate ?
                                    <li style={{ marginLeft: '0px', marginRight: '50px' }} title='Class'>
                                      <FontAwesomeIcon icon={faTruck} className={classes.btnIcon} /> <br />
                                      {volumeClassCountDate}
                                    </li> : null
                                }
                                {
                                  traffiSpeedCountDate ?
                                    <li style={{ marginLeft: '0px', marginRight: '50px' }} title='Speed'>
                                      <FontAwesomeIcon icon={faTachometerAlt} className={classes.btnIcon} /> <br />
                                      {traffiSpeedCountDate}
                                    </li> : null
                                }
                              </ul> :
                              <p style={{ textAlign: 'center' }}>
                                No data has been imported for this station
                          </p>
                          }
                        </Paper>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </fieldset>
              <fieldset className={classes.fieldsetname}>
                <legend style={{ marginBottom: '-10px', }}>Summary</legend>
                {
                  (getADTSummery.length > 0 || getTruckPercent.length > 0 || getADTGrowthFactor.length > 0) ?
                    <TableContainer component={Paper}>
                      <Table className={classes.tableMidBlock} aria-label="customized table">
                        <TableHead>
                          <TableRow>
                            <TableCell className={classes.tableHead}></TableCell>
                            {
                              yearList &&
                              yearList.map((year, index) => {
                                return <TableCell key={index} className={classes.tableHead}> {year.year} </TableCell>
                              })
                            }
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <StyledTableRow>
                            <TableCell className={classes.titleTD}>Average Daily Traffic (ADT)</TableCell>
                            {
                              getADTSummery &&
                              getADTSummery.map((adtsummery, index) => {
                                return <TableCell key={index} className={classes.dataTD}> {adtsummery.value} </TableCell>
                              })
                            }
                          </StyledTableRow>

                          <StyledTableRow>
                            <TableCell className={classes.titleTD}>Truck %</TableCell>
                            {
                              getTruckPercent &&
                              getTruckPercent.map((truckpercent, index) => {
                                if (truckpercent.value != "N/A") {
                                  return <TableCell key={index} className={classes.dataTD}> {truckpercent.value}% </TableCell>
                                }
                                else {
                                  return <TableCell key={index} className={classes.dataTD}> {truckpercent.value} </TableCell>
                                }
                              })
                            }
                          </StyledTableRow>

                          <StyledTableRow>
                            <TableCell className={classes.titleTD}>ADT Annual Growth Rate</TableCell>
                            {
                              getADTGrowthFactor &&
                              getADTGrowthFactor.map((growthfactor, index) => {
                                if (growthfactor.value != "N/A") {
                                  return <TableCell key={index} className={classes.dataTD}> {growthfactor.value}% </TableCell>
                                }
                                else {
                                  return <TableCell key={index} className={classes.dataTD}> {growthfactor.value} </TableCell>
                                }
                              })
                            }
                          </StyledTableRow>
                        </TableBody>
                      </Table>
                    </TableContainer> : <p style={{ textAlign: 'center' }}> No summary calculations are available for this station </p>
                }
              </fieldset>

              <fieldset className={classes.fieldsetname}>
                <legend>ADT</legend>
                <div className={classes.echartDiv}>
                  {
                    eChartGet > 0 ?
                      <ReactEcharts option={myOptions} style={{ marginLeft: '5px' }} /> :
                      <p style={{ textAlign: "center" }}> No ADT calculations are available for this station </p>
                  }
                </div>
              </fieldset>

              <fieldset className={classes.fieldsetname}>
                <legend>Details</legend>
                <Grid container className={classes.rootBox} spacing={spacing}>
                  <Grid item xs={12}>
                    <Grid container justify="center" spacing={spacing}>
                      <Grid xs={12} item>
                        <Paper className={classes.paper} >
                          <span style={{ textTransform: 'capitalize' }}>
                            Status: {stationData && stationData.status ? stationData.status : 'N/A'}
                          </span> <br />
                          <span>
                            Jurisdiction: {stationData && stationData.Jurisdiction_name ? stationData.Jurisdiction_name : 'N/A'}
                          </span> <br />
                          <span>
                            County: {stationData && stationData.fips_county_code ? stationData.fips_county_code : 'N/A'}
                          </span> <br />
                          <span>
                            Community: {stationData && stationData.community ? stationData.community : 'N/A'}
                          </span> <br />
                          <span>
                            Lat / Long: {stationData && stationData.latitude ? parseFloat(stationData.latitude).toFixed(5) : null}, {stationData && stationData.longitude ? parseFloat(stationData.longitude).toFixed(5) : null}
                          </span> <br />
                          <span>
                            Speed Limit: {stationData && stationData.speed_limit ? stationData.speed_limit : 'N/A'}
                          </span> <br />
                          <span>
                            Description: {stationData && stationData.description ? stationData.description : 'N/A'}
                          </span> <br />
                        </Paper>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </fieldset>
            </Typography>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default MidBlock;

//End MidBlock component code ...
